import React from 'react'
import PropTypes from 'prop-types'

export default function CategoryItem({ category, checked, onChange }) {
  return (
    <li key={category}>
      <label
        htmlFor={category}
        className="Grid Grid--alignMiddle Grid--fit u-marginBottom4gu u-posRelative"
      >
        <h4 className="u-textColorWhite">{category}</h4>
        <input
          className="Checkbox-cti u-margin2gu"
          id={category}
          name={category}
          type="checkbox"
          value={category}
          checked={checked}
          onChange={(event) => onChange(category, event.target.checked)}
        ></input>
        <span className="Icon Icon--after u-posAbsolute">&#xf107;</span>
      </label>
    </li>
  )
}

CategoryItem.propTypes = {
  category: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}
